export const SET_LOGIN = '@config/SET_LOGIN';
export const SET_LOGOUT = '@config/SET_LOGOUT';
export const SET_INVALID_TOKEN = '@config/SET_INVALID_TOKEN';
